import '../typography/index'
import '../button/index'
import '../media/index'
import '../badge/index'
import './oct-card.scss'

//const $_prefix = 'oct-card'

class OCTCard {
  constructor (el) {
    if (el.__OCTCard) return this

    this.el = el

    this.el.__OCTCard = this
  }

  scrollHandler () {
  }
}

document.addEventListener('DOMContentLoaded', event => { // eslint-disable-line no-unused-vars
  // set scroll into view
  Array.from(document.querySelectorAll('.oct-card')).forEach(el => {
    new OCTCard(el)
  })

  if (process.env.NODE_ENV === 'development')
    console.info('[OCT] Intializing OCTCard...')
})
